module.exports = __webpack_public_path__ + "static/assets/887952bfa90f468a5dc5ce1e4c6c4a61.png";